import { render, staticRenderFns } from "./redesInvolucrado.vue?vue&type=template&id=2c891504&"
import script from "./redesInvolucrado.vue?vue&type=script&lang=js&"
export * from "./redesInvolucrado.vue?vue&type=script&lang=js&"
import style0 from "./redesInvolucrado.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports